// Expose moment globally for bootstrap-datetimepicker and legacy code
// that references the bare `moment` global.
import moment from "moment"

window.moment = moment

export default moment
